import FaCamera from "@/components/SVG/Fontawesome/FaCamera";
import FaKeyboard from "@/components/SVG/Fontawesome/FaKeyboard";
import FaMicrophone from "@/components/SVG/Fontawesome/FaMicrophone";
import { selectCameraBSTabIndex, updateOffCanvasViewPayload } from "@/store/slices/offCanvas";
import { memo, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

const Tabs = () => {
  const dispatch = useDispatch();
  const selectedIndex = useSelector(selectCameraBSTabIndex);

  const tabs = useMemo(() => [{
    icon: FaMicrophone,
    title: "Audio Search",
    iconClassName: "h-4 w-4",
  }, {
    icon: FaCamera,
    title: "Camera",
    iconClassName: "h-4 w-4",
  }, {
    icon: FaKeyboard,
    title: "Type Doubt",
    iconClassName: "h-4 w-4",
  }], []);

  const changeTabs = (index: number) => {
    dispatch(updateOffCanvasViewPayload({ CAMERA: { cameraBSTabIndex: index } }));
  }

  return (
    <div className="grid grid-cols-3 w-full justify-items-center place-items-center text-sm h-8 text-white">
      {
        tabs.map((tab, i) => {
          if (selectedIndex === i) {
            tab.iconClassName = `${tab.iconClassName ?? ""} fill-black`;
          } else {
            tab.iconClassName = `${tab.iconClassName ?? ""} fill-white`;
          }
          return <button key={i} className={`px-2 py-1 rounded-xl flex items-center gap-1 ${selectedIndex === i ? "bg-gray-300 text-black" : ""}`} onClick={() => changeTabs(i)}>
            {tab.icon({ className: tab.iconClassName })}
            <span>{tab.title}</span>
          </button>
        })
      }
    </div>
  );
}

export default memo(Tabs);